// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-button {
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  background: #ffffff;
  border: none;
  margin: 0px 6px;
  border-bottom: none;
  cursor: pointer;
}

.horizontal-rule {
  width: 184px;
  height: 0px;
  border: 1px solid #cccccc;
}

.arrow-up {
  color: #cc0000;
  width: 16px;
  height: 16px;
}

.table {
  background: #ffffff;
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  table-layout: fixed;
}

.search-results-table-container {
  width: 100%;
  overflow-x: hidden;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.results-layout {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-left: 1rem;
  margin-right: 1rem;
}

.results-table-col {
  flex: 1 1 640px;
  min-width: 0;
}

.browse-results-layout {
  margin-left: 0;
  margin-right: 0;
}

.browse-results-col {
  margin: 0 15px;
}

.browse-results-table-container {
  width: 100%;
  overflow-x: auto;
}

.browse-results-collection-col {
  padding-left: 23px !important;
}

.browse-results-pages-col {
  padding-right: 23px !important;
}

.desktop-left-pane {
  margin-left: 60px;
  max-width: 20%;
}

.table-head {
  font-family: "Roboto";
  font-style: normal;
  color: #666666;
  border-bottom: 1px solid #e5e5e5;
  font-weight: 600;
}

.table thead th {
  padding: 16px 12px;
  text-align: left;
}

.table thead th span {
  font-size: 0.8rem;
  color: #888;
}

.table .table-th {
  white-space: nowrap;
}

.table .table-th span {
  display: inline-block;
  margin-left: 4px;
  font-size: 0.8rem;
  color: #888;
}

.table-th-2 {
  padding: 18px 16px 15px;
  font-weight: normal;
  vertical-align: middle;
  text-align: left;
}

/* Column widths */
.format-col {
  width: 12%;
  padding-left: 23px;
}

.title-col {
  width: 28%;
}

.date-col,
.location-col,
.source-col,
.pages-col {
  width: 15%;
}

/* Table cell styles */
.table td {
  padding: 12px 12px;
  vertical-align: middle;
  border-bottom: 1px solid #e5e5e5;
}

/* Icon styles */
.table-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
}

/* Title text styles */
.title-text {
  font-weight: bold;
  font-family: "Roboto Slab";
  color: #12394d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.visited-row {
  color: purple !important;
}

/* Hover effect */
.table tr:hover {
  background-color: #f8f9fa;
  cursor: pointer;
}

.ellipsis {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsis2 {
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filters {
  display: none;
}

.analytics-button {
  border: 2px solid #1a1a1a;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  width: 130px;
  background-color: #e5e5e5;
}

.filter-button {
  border: 2px solid #cc0000;
  color: #cc0000;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  width: 130px;
  background-color: #e5e5e5;
}

.modal-title-style {
  margin: 0;
  padding: 12px;
  font-weight: 700;
  font-size: 30px;
  color: #12394d;
}

.filter-modal-title {
  margin: 0;
  padding: 12px;
  font-weight: 700;
  font-size: 30px;
  color: #12394d;
}

.modal-body > .left-pane-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.rag-summary {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(18, 57, 77, 0.12);
  margin: 24px auto 0;
  width: min(90%, 860px);
  padding: 20px 28px;
}

.rag-summary h4 {
  font-family: "Roboto Slab";
  font-size: 20px;
  margin: 0 0 10px;
  color: #12394d;
}

.rag-summary p {
  margin: 0;
  font-family: "Roboto";
  font-size: 16px;
  line-height: 1.6;
  color: #1a1a1a;
  white-space: pre-wrap;
}

@media (max-width: 1024px) {
  .left-pane {
    display: none;
  }

  .filters {
    display: flex;
    justify-content: space-around;
  }

  .results-layout {
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 992px) {
  .results-table-col {
    flex-basis: 100%;
  }
}

@media (max-width: 768px) {
  .search-results-table-container table,
  .search-results-table-container thead,
  .search-results-table-container tbody,
  .search-results-table-container th,
  .search-results-table-container td,
  .search-results-table-container tr {
    display: block;
  }

  .search-results-table-container thead {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .search-results-table-container tr {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 18px;
    border: 1px solid #e5e5e5;
    border-radius: 12px;
    padding: 18px 20px;
    background: #ffffff;
    box-shadow: 0 8px 18px rgba(18, 57, 77, 0.08);
  }

  .desktop-left-pane {
    display: none;
  }

  .results-table-col {
    flex-basis: 100%;
  }

  .table {
    table-layout: auto;
  }

  .table thead th {
    font-size: 0.85rem;
    padding: 12px 8px;
  }

  .table td {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 18px 0 0;
    border: none;
    font-size: 0.95rem;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  }

  .table td:not(:last-child) {
    padding-bottom: 16px;
    border-bottom: 1px solid #f1f1f1;
  }

  .table td::before {
    content: attr(data-label);
    position: absolute;
    top: 0;
    left: 0;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #7c8a96;
  }

  .table-icon {
    margin-right: 10px;
  }

  .format-col {
    font-weight: 600;
    text-transform: capitalize;
    letter-spacing: 0.03em;
  }

  .title-col {
    padding-top: 16px;
  }

  .title-col::before {
    top: -2px;
  }

  .title-text {
    white-space: normal;
    line-height: 1.3;
    font-size: 1rem;
  }

  .browse-results-col {
    margin: 0 8px;
  }

  .browse-results-table-container {
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  .browse-results-table-container table,
  .browse-results-table-container thead,
  .browse-results-table-container tbody,
  .browse-results-table-container th,
  .browse-results-table-container td,
  .browse-results-table-container tr {
    display: block;
  }

  .browse-results-table-container thead {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .browse-results-table-container tr {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 14px;
    border: 1px solid #e5e5e5;
    border-radius: 12px;
    padding: 18px 16px;
    background: #fff;
    box-shadow: 0 8px 18px rgba(18, 57, 77, 0.08);
  }

  .browse-results-table-container td {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 18px 0 0 !important;
    border: none;
    font-size: 0.95rem;
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  }

  .browse-results-table-container td:not(:last-child) {
    padding-bottom: 16px !important;
    border-bottom: 1px solid #f1f1f1;
  }

  .browse-results-table-container td::before {
    content: attr(data-label);
    position: absolute;
    top: 0;
    left: 0;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #7c8a96;
  }

  .browse-results-table-container .title-text {
    white-space: normal;
    line-height: 1.3;
    font-size: 1rem;
  }

  .browse-results-table-container .ellipsis,
  .browse-results-table-container .ellipsis2 {
    max-width: 100%;
    white-space: normal;
  }

  .browse-results-collection-col,
  .browse-results-pages-col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .browse-results-col {
    margin: 0 12px;
  }

  .browse-results-table-container {
    overflow-x: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/search-results.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;;;IAME,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;EAC/C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA;;;;;;IAME,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,6CAA6C;EAC/C;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".pagination-button {\n  box-sizing: border-box;\n  width: 36px;\n  height: 36px;\n  background: #ffffff;\n  border: none;\n  margin: 0px 6px;\n  border-bottom: none;\n  cursor: pointer;\n}\n\n.horizontal-rule {\n  width: 184px;\n  height: 0px;\n  border: 1px solid #cccccc;\n}\n\n.arrow-up {\n  color: #cc0000;\n  width: 16px;\n  height: 16px;\n}\n\n.table {\n  background: #ffffff;\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  table-layout: fixed;\n}\n\n.search-results-table-container {\n  width: 100%;\n  overflow-x: hidden;\n  background: #ffffff;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.results-layout {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px;\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.results-table-col {\n  flex: 1 1 640px;\n  min-width: 0;\n}\n\n.browse-results-layout {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.browse-results-col {\n  margin: 0 15px;\n}\n\n.browse-results-table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.browse-results-collection-col {\n  padding-left: 23px !important;\n}\n\n.browse-results-pages-col {\n  padding-right: 23px !important;\n}\n\n.desktop-left-pane {\n  margin-left: 60px;\n  max-width: 20%;\n}\n\n.table-head {\n  font-family: \"Roboto\";\n  font-style: normal;\n  color: #666666;\n  border-bottom: 1px solid #e5e5e5;\n  font-weight: 600;\n}\n\n.table thead th {\n  padding: 16px 12px;\n  text-align: left;\n}\n\n.table thead th span {\n  font-size: 0.8rem;\n  color: #888;\n}\n\n.table .table-th {\n  white-space: nowrap;\n}\n\n.table .table-th span {\n  display: inline-block;\n  margin-left: 4px;\n  font-size: 0.8rem;\n  color: #888;\n}\n\n.table-th-2 {\n  padding: 18px 16px 15px;\n  font-weight: normal;\n  vertical-align: middle;\n  text-align: left;\n}\n\n/* Column widths */\n.format-col {\n  width: 12%;\n  padding-left: 23px;\n}\n\n.title-col {\n  width: 28%;\n}\n\n.date-col,\n.location-col,\n.source-col,\n.pages-col {\n  width: 15%;\n}\n\n/* Table cell styles */\n.table td {\n  padding: 12px 12px;\n  vertical-align: middle;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n/* Icon styles */\n.table-icon {\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n\n/* Title text styles */\n.title-text {\n  font-weight: bold;\n  font-family: \"Roboto Slab\";\n  color: #12394d;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.visited-row {\n  color: purple !important;\n}\n\n/* Hover effect */\n.table tr:hover {\n  background-color: #f8f9fa;\n  cursor: pointer;\n}\n\n.ellipsis {\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ellipsis2 {\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.filters {\n  display: none;\n}\n\n.analytics-button {\n  border: 2px solid #1a1a1a;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  width: 130px;\n  background-color: #e5e5e5;\n}\n\n.filter-button {\n  border: 2px solid #cc0000;\n  color: #cc0000;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  width: 130px;\n  background-color: #e5e5e5;\n}\n\n.modal-title-style {\n  margin: 0;\n  padding: 12px;\n  font-weight: 700;\n  font-size: 30px;\n  color: #12394d;\n}\n\n.filter-modal-title {\n  margin: 0;\n  padding: 12px;\n  font-weight: 700;\n  font-size: 30px;\n  color: #12394d;\n}\n\n.modal-body > .left-pane-modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rag-summary {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 12px 24px rgba(18, 57, 77, 0.12);\n  margin: 24px auto 0;\n  width: min(90%, 860px);\n  padding: 20px 28px;\n}\n\n.rag-summary h4 {\n  font-family: \"Roboto Slab\";\n  font-size: 20px;\n  margin: 0 0 10px;\n  color: #12394d;\n}\n\n.rag-summary p {\n  margin: 0;\n  font-family: \"Roboto\";\n  font-size: 16px;\n  line-height: 1.6;\n  color: #1a1a1a;\n  white-space: pre-wrap;\n}\n\n@media (max-width: 1024px) {\n  .left-pane {\n    display: none;\n  }\n\n  .filters {\n    display: flex;\n    justify-content: space-around;\n  }\n\n  .results-layout {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n@media (max-width: 992px) {\n  .results-table-col {\n    flex-basis: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .search-results-table-container table,\n  .search-results-table-container thead,\n  .search-results-table-container tbody,\n  .search-results-table-container th,\n  .search-results-table-container td,\n  .search-results-table-container tr {\n    display: block;\n  }\n\n  .search-results-table-container thead {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  .search-results-table-container tr {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 18px;\n    border: 1px solid #e5e5e5;\n    border-radius: 12px;\n    padding: 18px 20px;\n    background: #ffffff;\n    box-shadow: 0 8px 18px rgba(18, 57, 77, 0.08);\n  }\n\n  .desktop-left-pane {\n    display: none;\n  }\n\n  .results-table-col {\n    flex-basis: 100%;\n  }\n\n  .table {\n    table-layout: auto;\n  }\n\n  .table thead th {\n    font-size: 0.85rem;\n    padding: 12px 8px;\n  }\n\n  .table td {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 18px 0 0;\n    border: none;\n    font-size: 0.95rem;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: clip;\n  }\n\n  .table td:not(:last-child) {\n    padding-bottom: 16px;\n    border-bottom: 1px solid #f1f1f1;\n  }\n\n  .table td::before {\n    content: attr(data-label);\n    position: absolute;\n    top: 0;\n    left: 0;\n    font-size: 0.7rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: #7c8a96;\n  }\n\n  .table-icon {\n    margin-right: 10px;\n  }\n\n  .format-col {\n    font-weight: 600;\n    text-transform: capitalize;\n    letter-spacing: 0.03em;\n  }\n\n  .title-col {\n    padding-top: 16px;\n  }\n\n  .title-col::before {\n    top: -2px;\n  }\n\n  .title-text {\n    white-space: normal;\n    line-height: 1.3;\n    font-size: 1rem;\n  }\n\n  .browse-results-col {\n    margin: 0 8px;\n  }\n\n  .browse-results-table-container {\n    border-radius: 8px;\n    background: #fff;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  }\n\n  .browse-results-table-container table,\n  .browse-results-table-container thead,\n  .browse-results-table-container tbody,\n  .browse-results-table-container th,\n  .browse-results-table-container td,\n  .browse-results-table-container tr {\n    display: block;\n  }\n\n  .browse-results-table-container thead {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  .browse-results-table-container tr {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin-bottom: 14px;\n    border: 1px solid #e5e5e5;\n    border-radius: 12px;\n    padding: 18px 16px;\n    background: #fff;\n    box-shadow: 0 8px 18px rgba(18, 57, 77, 0.08);\n  }\n\n  .browse-results-table-container td {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 18px 0 0 !important;\n    border: none;\n    font-size: 0.95rem;\n    white-space: normal;\n    overflow: visible;\n    text-overflow: clip;\n  }\n\n  .browse-results-table-container td:not(:last-child) {\n    padding-bottom: 16px !important;\n    border-bottom: 1px solid #f1f1f1;\n  }\n\n  .browse-results-table-container td::before {\n    content: attr(data-label);\n    position: absolute;\n    top: 0;\n    left: 0;\n    font-size: 0.7rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: #7c8a96;\n  }\n\n  .browse-results-table-container .title-text {\n    white-space: normal;\n    line-height: 1.3;\n    font-size: 1rem;\n  }\n\n  .browse-results-table-container .ellipsis,\n  .browse-results-table-container .ellipsis2 {\n    max-width: 100%;\n    white-space: normal;\n  }\n\n  .browse-results-collection-col,\n  .browse-results-pages-col {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .browse-results-col {\n    margin: 0 12px;\n  }\n\n  .browse-results-table-container {\n    overflow-x: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
